import { render, staticRenderFns } from "./AddReliefs.vue?vue&type=template&id=f53199bc&scoped=true"
import script from "./AddReliefs.vue?vue&type=script&lang=js"
export * from "./AddReliefs.vue?vue&type=script&lang=js"
import style0 from "./AddReliefs.vue?vue&type=style&index=0&id=f53199bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f53199bc",
  null
  
)

export default component.exports